import { render } from "./UserTable.vue?vue&type=template&id=6506e388&scoped=true"
import script from "./UserTable.vue?vue&type=script&lang=js"
export * from "./UserTable.vue?vue&type=script&lang=js"

import "./UserTable.vue?vue&type=style&index=0&id=6506e388&scoped=true&lang=css"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6506e388"]])

export default __exports__